import { render } from "./AccountType.vue?vue&type=template&id=78149c53&ts=true"
import script from "./AccountType.vue?vue&type=script&lang=ts"
export * from "./AccountType.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__